import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getPersonEquipments = (personId) => {
  return dispatch => {
    dispatch({ type: "GET_PERSON_EQUIPMENTS_LOADING" });
    api
      .equipmentsGetPerson(personId)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
        dispatch({ type: "GET_PERSON_EQUIPMENTS_LOADING_DONE" });
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_PERSON_EQUIPMENTS_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetPersonEquipmentsErrorAlertTitle",
          "Virhe henkilön välineistön tai käyttöoikeuden haussa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_PERSON_EQUIPMENTS_SUCCEEDED",
  payload: { equipments: data },
});

const operationFail = () => ({
  type: "GET_PERSON_EQUIPMENTS_FAIL"
});
